import React from 'react'
import { Box } from '@mui/joy'

const CellPhoneNumber = ({ value }) => {
	const mask = v => v ? v.slice(0, 3) + '•••' + v.slice(6) : ''

	return (
		<Box className="list-element-cell">
			{value && <span className="phone">{mask(value)}</span>}
		</Box>
	)
}

export default CellPhoneNumber
